// import React, { useEffect, useState, useContext } from 'react';
// import { useNavigate } from 'react-router-dom';
// import './OverallShares.css';
// import axios from '../../api/axiosInstance';
// import { FilterContext } from '../../components/pages/FilterContext';
// import Filters from './Filters';
// import FilterTabs from './FilterTabs';
// import config from '../../config';

// const PaymentTable = () => {
//   const { selectedFilters, DisplayFiltersName } = useContext(FilterContext);
//   const [tableData, setTableData] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [uniqueYears, setUniqueYears] = useState([]);
//   const [data, setData] = useState(null);
//   const [filterTabs, setFilterTabs] = useState({});
//   const [apiCalled, setApiCalled] = useState(false);


//   const navigate = useNavigate();

//   const handleFilterUpdate = (filterType, filteredValues) => {
//     setFilterTabs((prevTabs) => ({
//       [filterType]: filteredValues.map((item) => item.value),
//     }));
//   };

//   const filterTabKey = Object.keys(filterTabs)[0];

//   useEffect(() => {
//     setUniqueYears([]);
//     let updatedfilterTabs = filterTabs
//     if (filterTabs["trans_year"])
//       updatedfilterTabs = {}
//     if (selectedFilters && Object.keys(selectedFilters).length > 0) {
//       const filteredFilters = Object.fromEntries(
//         Object.entries(selectedFilters).filter(([key, value]) => Array.isArray(value) && value.length > 0)
//     );
//     if (Object.keys(filteredFilters).length > 0) {
//       setLoading(true);
//       setApiCalled(false);
//       setTableData([]);
//       axios
//         .post(`${config.API_BASE_URL}/api/payment-data`, {
//           selectedFilters,
//           updatedfilterTabs,
//         })
//         .then((response) => {
//           const data = Array.isArray(response.data) ? response.data : [];
//           const sortedData = data.sort((a, b) => {
//             if (a.payment === 'Other') return 1;  // "Other" goes to the end
//             if (b.payment === 'Other') return -1; // "Other" goes to the end
//             return 0; // Keep the rest in the same order
//           });

//           setTableData(sortedData);
//           // console.log("Total", data)
//           setApiCalled(true);
//           setLoading(false);
//           let dynamicPattern = null;

//           if (Object.keys(updatedfilterTabs).length === 0) {
//             const yearPatternWithSuffix = /_(\d{4}_\d)$/;
//             const yearPatternWithoutSuffix = /_(\d{4})$/;

//             const hasYearWithSuffix = sortedData.some((row) =>
//               Object.keys(row).some((key) => yearPatternWithSuffix.test(key))
//             );

//             const years = Array.from(
//               new Set(
//                 sortedData.flatMap((row) =>
//                   Object.keys(row)
//                     .filter((key) => key.startsWith('perc_') || key.startsWith('shares_'))
//                     .map((key) =>
//                       (hasYearWithSuffix
//                         ? key.match(yearPatternWithSuffix)
//                         : key.match(yearPatternWithoutSuffix))?.[1]
//                     )
//                     .filter(Boolean)
//                 )
//               )
//             );
//             setUniqueYears(years);
//           }
//           else if (Object.keys(updatedfilterTabs).length > 0 && Object.keys(selectedFilters).length > 0) {

//             // console.log("selectedFilter:", updatedfilterTabs);
//             const dynamicFilterKey = Object.keys(updatedfilterTabs)[0] || 'user_gender';
//             // const genderYearPattern = /_(\w+)_(\d{4})$/;
//             const genderYearPattern = new RegExp(
//               `${dynamicFilterKey}_(\\w+)_(\\d{4})$`
//             );
//             const selectedFilter = updatedfilterTabs.selectedFilter || {}; // or another key depending on your structure
//             // console.log("selectedFilter:", selectedFilter); // Debugging line

//             const extractedColumns = Array.from(
//               new Set(
//                 sortedData.flatMap((row) =>
//                   Object.keys(row)
//                     .filter((key) => genderYearPattern.test(key) || key.startsWith("perc_"))
//                     .map((key) => {
//                       const match = key.match(genderYearPattern);
//                       return match ? `${match[1]}_${match[2]}` : key;
//                     })
//                     .filter(Boolean)
//                 )
//               )
//             );

//             setUniqueYears(extractedColumns);
//           }
//           else {
//             const dynamicFilterKey = Object.keys(updatedfilterTabs)[0] || 'user_gender';
//             dynamicPattern = new RegExp(
//               `${dynamicFilterKey}_(\\w+)_(\\d{4})_(\\d)`
//             );

//             const extractedYears = Array.from(
//               new Set(
//                 sortedData.flatMap((row) =>
//                   Object.keys(row)
//                     .filter((key) => key.startsWith('perc_') || key.startsWith('shares_'))
//                     .map((key) => {
//                       const match = key.match(dynamicPattern);
//                       return match ? `${match[1]}_${match[2]}_${match[3]}` : null;
//                     })
//                     .filter(Boolean)
//                 )
//               )
//             );
//             setUniqueYears(extractedYears);
//           }
//           setError('');
//           setApiCalled(true);
//           setLoading(false);

//         })
//         .catch((err) => {
//           console.error('Error fetching table data:', err);
//           setError('Failed to load data.');
//           setApiCalled(true);
//           setLoading(false);
//         });
//     } }else {
//       // Handle the case when there are no selected filters
//       setLoading(false);
//       setTableData([]);
//       setApiCalled(false);
//     }
//   }, [selectedFilters, filterTabs]);

//   useEffect(() => {
//     if (selectedFilters && Object.keys(selectedFilters).length > 0) {
//     // Filter the selectedFilters to remove empty arrays
//     const filteredFilters = Object.fromEntries(
//         Object.entries(selectedFilters).filter(([key, value]) => 
//             Array.isArray(value) && value.length > 0
//         )
//     );

//     if (Object.keys(filteredFilters).length > 0) {
//         // Pass the filtered filters as where_clause for filtering
//         const whereClause = JSON.stringify(filteredFilters);

//         setLoading(true);
//         fetch(`${config.API_BASE_URL}/api/data-summary`, {
//             method: 'POST',
//             headers: {
//                 'Content-Type': 'application/json',
//             },
//             body: JSON.stringify({
//                 where_clause: whereClause, // Pass filtered filters as the where_clause
//             }),
//         })
//             .then((response) => response.json())
//             .then((data) => {
//               setData(data);
//                 setLoading(false);
//             })
//             .catch((error) => {
//                 console.error('Error fetching data summary:', error);
//                 setError('Failed to fetch data summary');
//                 setLoading(false);
//             });
//     } }else {
//       setData([]);
//     }
// }, [selectedFilters]);



//   const goBack = () => {
//     navigate('/dashboards');
//   };

//   // const processedYears = uniqueYears
//   //   .map((year) => ({
//   //     original: year,
//   //     year: parseInt(year.match(/\d{4}/)[0]),
//   //   }))
//   //   .sort((a, b) => b.year - a.year)
//   //   .map((item) => item.original);

//   const processedYears = uniqueYears
//     .map((year) => {
//       const baseRow = tableData.find((row) => row.payment === 'Base');
//       const percValue = baseRow ? baseRow[`perc_${filterTabKey}_${year}`] : undefined;

//       // Only keep the year if the perc value is not 0
//       return percValue !== 0
//         ? {
//           original: year,
//           year: parseInt(year.match(/\d{4}/)[0]),
//         }
//         : null;
//     })
//     .filter(Boolean) // Remove null entries where the perc value was 0
//     .sort((a, b) => b.year - a.year)
//     .map((item) => item.original);

//     const renderSelectedFilters = () => {
//       let renderedTransYear = false; // Flag to track if 'trans_year' has been rendered
//       const subCategoryValues = []; // To accumulate sub-category values
//       const renderContent = [];

//       // Loop through the filter names and render them
//       Object.keys(DisplayFiltersName).map((displayName) => {
//         const filterKey = DisplayFiltersName[displayName]; // Get the object for the current display name

//         // If the filterKey is an array (like 'trans_year' or any other arrays), handle them
//         if (Array.isArray(filterKey)) {
//           // If it's 'trans_year' and has not been rendered, render it
//           if (displayName === "trans_year" && !renderedTransYear) {
//             renderedTransYear = true;
//             renderContent.push(
//               <span key={displayName} className="selected-filter">
//                 <strong>Year: </strong>{filterKey.join(", ")}
//               </span>
//             );
//           }
//           return; // Skip further handling for arrays (no need to process this again)
//         }

//         // Get the keys from the filterKey object (like user_age, user_gender)
//         const filterKeys = Object.keys(filterKey);

//         // Loop through each filter key (like user_age, user_gender)
//         filterKeys.map((key) => {
//           const filterValues = selectedFilters[key];

//           // Skip rendering if filterValues is empty or undefined
//           if (!filterValues || (Array.isArray(filterValues) && filterValues.length === 0)) {
//             return null;
//           }

//           // Skip rendering 'trans_year' if it's already been rendered
//           if (key === "trans_year" && renderedTransYear) {
//             return; // Skip if 'trans_year' has already been rendered
//           }

//           // Special handling for sub-categories
//           if (displayName === "Sub-Categories" || key.startsWith("SubCat_")) {
//             if (Array.isArray(filterValues)) {
//               subCategoryValues.push(...filterValues); // Collect sub-category values
//             } else {
//               subCategoryValues.push(filterValues);
//             }
//             return null; // Skip rendering immediately
//           }

//           // For other filters, display the regular displayName
//           const displayKey = key === "trans_year" ? "Year" : displayName;
//           const displayValues = Array.isArray(filterValues) ? filterValues.join(", ") : filterValues;

//           renderContent.push(
//             <span key={key} className="selected-filter">
//               <strong>{displayKey}: </strong>{displayValues}
//             </span>
//           );
//         });
//       });

//       // Render the combined sub-categories at the end, only if they exist
//       if (subCategoryValues.length > 0) {
//         renderContent.push(
//           <span key="sub-categories" className="selected-filter">
//             <strong>Sub-Categories: </strong>{subCategoryValues.join(", ")}
//           </span>
//         );
//       }

//       return renderContent;
//     };




//   return (
//     <div className="container">
//       <Filters pageSpecificFilters="payment" />
//       <div className="table-section">
//         <button onClick={goBack} className="back-button">
//           &#8592; Back
//         </button>
//         {/* Render selected filters before FilterTabs */}
//         <div className="selected-filters-display">
//           {renderSelectedFilters()}
//         </div>

//         <FilterTabs onFilterUpdate={handleFilterUpdate} />

//         <div>
//           <table>
//             <thead>
//               <tr>
//                 <th className="total-transac">
//                   <u>Total Transactions</u>
//                   <br />
//                   <label className="label">
//                     <i>
//                       <strong>Base:</strong> {data?.trans?.toLocaleString()}
//                     </i>
//                   </label>
//                 </th>
//                 <th className="share-column">Share of Transactions</th>
//               </tr>
//             </thead>
//           </table>
//         </div>

//         {loading ? (
//           <div className="loader-container">
//             <div className="loader"></div>
//           </div>
//         ) : error ? (
//           <p className="error">{error}</p>
//         ) : (!loading && apiCalled && tableData.length === 0 && Object.keys(selectedFilters).length > 0 && !error) ? (
//           // Show this message only if no data is returned AND filters are applied
//           <p className="no-data">No data available for the selected filters.</p>
//         ) : (
//           <div className="tablesview">
//             <table>
//               {Object.keys(selectedFilters).length > 0 ? (
//                 <thead>
//                   <tr>
//                     <th rowSpan="2">Payment Methods</th>
//                     {/* Generate Year headers dynamically with colSpan */}
//                     {Array.from(new Set(
//                       processedYears.map((year) => year.split('_')[year.split('_').length - 1])
//                     )).map((year) => {
//                       if (year === "0" || year.startsWith("Total")) return null; // Skip if year is "0" or a Total key
//                       const count = processedYears.filter((y) => y.endsWith(`_${year}`)).length;
//                       return (
//                         <th key={year} colSpan={count}>
//                           {year}
//                         </th>
//                       );
//                     })}
//                   </tr>
//                   <tr>
//                     {/* Display the group names, without showing the year */}
//                     {processedYears.map((year, index) => (
//                       <th key={index}>
//                         {year.startsWith("perc")
//                           ? "Total"  // Label for Total columns
//                           : (filterTabKey === "user_age"
//                             ? year.includes("65__")  // Special case for "65__"
//                               ? "65+"  // Replace "65__" with "65+"
//                               : year.replace("_", "-").split('_').slice(0, -1).join('_')  // Replace first "_" with "-" for others
//                             : year.split('_').slice(0, -1).join('_'))}  {/* Remove year part or transform based on filterTabKey */}
//                       </th>
//                     ))}
//                   </tr>
//                 </thead>
//               ) : (
//                 <thead>
//                   <tr>
//                     <th rowSpan="2">Payment Methods</th>
//                     {/* Generate Year headers dynamically with colSpan */}
//                     {Array.from(new Set(
//                       processedYears.map((year) => year.split('_')[year.split('_').length - 2])
//                     )).map((year) => {
//                       if (year === "0" || year.startsWith("Total")) return null; // Skip if year is "0" or a Total key
//                       const count = processedYears.filter((y) => y.endsWith(`_${year}_0`)).length;
//                       return (
//                         <th key={year} colSpan={count}>
//                           {year}
//                         </th>
//                       );
//                     })}
//                   </tr>
//                   <tr>
//                     {processedYears.map((year, index) => (
//                       <th key={index}>
//                         {year.startsWith("perc")
//                           ? "Total" // Label for Total columns
//                           : year.split('_').slice(0, -2).join('_')} {/* Extract the label part */}
//                       </th>
//                     ))}
//                   </tr>
//                 </thead>
//               )}
//               <tbody>
//                 {tableData
//                   .filter((row) => row.payment !== "") // Filter out rows where payment is an empty string
//                   .map((row, index) => (
//                     <tr
//                       key={index}
//                       style={{
//                         backgroundColor: row.payment === 'Base' ? '#c1c1c1' : 'transparent',
//                         whiteSpace: 'nowrap'
//                       }}
//                     >
//                       <td>
//                         {row.payment === "ReloadablePrePaid"
//                           ? "Reloadable/Pre-Paid"
//                           : row.payment === "E-Transfer"
//                             ? "Interac e-Transfer"
//                             : row.payment === "Base"
//                               ? <i>Base: Weighed number of transactions</i>
//                               : row.payment}
//                       </td>
//                       {processedYears.map((year) => (
//                         <td key={`perc_${year}`}>
//                           {year.startsWith("perc")
//                             ? row[year] !== undefined // Handle Total column separately
//                               ? row.payment === 'Base'
//                                 ? <i>{Number(row[year]).toLocaleString()}</i>
//                                 : Number(row[year]).toFixed(1)
//                               : "N/A"
//                             : row[`perc_${year}`] !== undefined
//                               ? row.payment === 'Base'
//                                 ? <i>{Number(row[`perc_${year}`]).toLocaleString()}</i>
//                                 : Number(row[`perc_${year}`]).toFixed(1)
//                               : row[`perc_${filterTabKey}_${year}`] !== undefined
//                                 ? row.payment === 'Base'
//                                   ? <i>{Number(row[`perc_${filterTabKey}_${year}`]).toLocaleString()}</i>
//                                   : Number(row[`perc_${filterTabKey}_${year}`]).toFixed(1)
//                                 : "N/A"}
//                         </td>
//                       ))}
//                     </tr>
//                   ))}
//               </tbody>
//             </table>

//           </div>
//         )}
//       </div>
//     </div>
//   );
// };

// export default PaymentTable;

import React, { useEffect, useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import './OverallShares.css';
import axios from '../../api/axiosInstance';
import { FilterContext } from '../../components/pages/FilterContext';
import Filters from './Filters';
import FilterTabs, { exportedFilters } from './FilterTabs';
import config from '../../config';
import { flushSync } from 'react-dom';
// import * as XLSX from 'sheetjs-style';
// import { saveAs } from 'file-saver';


const PaymentTable = () => {
  const { selectedFilters, DisplayFiltersName } = useContext(FilterContext);
  const [brands, setBrands] = useState([]);
  const [data, setData] = useState([]);
  const [waves, setWaves] = useState([]);
  const [statements, setStatements] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [filterTabs, setFilterTabs] = useState({});
  const [apiCalled, setApiCalled] = useState(false);
  const navigate = useNavigate();
  const [baseValue, setBaseValue] = useState(null);
  const [groupId, setGroupId] = useState(1); // default is 1
  const [isDownloading, setIsDownloading] = useState(false);


  const handleFilterUpdate = (filterType, filteredValues, groupId) => {
    setFilterTabs({
      [filterType]: filteredValues.map((item) => item.value),
    });
    if (groupId) {
      setGroupId(groupId); // dynamically set groupId
    }
  };

  useEffect(() => {
    if (selectedFilters && Object.keys(selectedFilters).length > 0) {
      const filteredFilters = Object.fromEntries(
        Object.entries(selectedFilters).filter(([key, value]) => Array.isArray(value) && value.length > 0)
      );

      if (Object.keys(filteredFilters).length > 0) {
        setLoading(true);
        setApiCalled(false);

        axios
          .post(`${config.API_BASE_URL}/api/Overallshares`, {
            selectedFilters,
            updatedfilterTabs: filterTabs,
            groupId: groupId,
          })
          .then((response) => {
            const { Brands, Data, Waves, Statement } = response.data;
            setBrands(response.data.Brands || []);
            setData(response.data.Data || []);
            setWaves(response.data.Waves || []);
            setStatements(response.data.Statement || []);
            // if (response.data.Data?.length > 0) {
            //   const seenWindex = new Set();
            //   let totalBase = 0;

            //   for (let i = 0; i < response.data.Data.length; i++) {
            //     const item = response.data.Data[i];
            //     if (!seenWindex.has(item.windex)) {
            //       totalBase += item.Base || 0;
            //       seenWindex.add(item.windex);
            //     }
            //   }
            //   const roundedBase = Math.round(totalBase);
            //   setBaseValue(roundedBase.toLocaleString());
            // }
            if (response.data.Data?.length > 0) {
              const baseByBindex = {};

              for (let i = 0; i < response.data.Data.length; i++) {
                const item = response.data.Data[i];
                const { bindex, sindex, Base } = item;

                // Skip total rows (if sindex is 'total' or not a number)
                if (isNaN(sindex)) continue;

                // Initialize for new bindex
                if (!baseByBindex[bindex]) {
                  baseByBindex[bindex] = 0;
                }

                baseByBindex[bindex] += Base || 0;
              }

              // If you want to set a specific baseValue (e.g. first bindex)
              const firstBindex = Object.keys(baseByBindex)[0];
              const roundedBase = Math.round(baseByBindex[firstBindex]);
              setBaseValue(roundedBase.toLocaleString());

              // Or log all statement base values
              // console.log("Base per statement:");
              for (const [bindex, base] of Object.entries(baseByBindex)) {
                // console.log(`Statement ${bindex}: ${Math.round(base).toLocaleString()}`);
              }
            }
            // console.log('Brands:', Brands);
            // console.log('Data:', Data);
            // console.log('Waves:', Waves);
            // console.log('Statements:', Statement);
            // Add a static "Total" statement from data if available
            let updatedStatements = [...(Statement || [])];

            // Check if there's a total row in Data that has Freq or other values > 0
            const hasValidTotalRow = (Data || []).some(item =>
              item.sindex === 'total' &&
              (item.Freq > 0 || item.Base > 0 || item.Perc > 0)
            );

            if (hasValidTotalRow) {
              const totalStatement = {
                Id: 'total',
                Name: 'Total',
                sindex: 'total',
                // Add any other necessary fields like GroupID if needed
              };

              updatedStatements = [totalStatement, ...updatedStatements];
            }

            setStatements(updatedStatements);

            setApiCalled(true);
            setLoading(false);
          })
          .catch((err) => {
            console.error('Error fetching data:', err);
            setError('Failed to load data.');
            setApiCalled(true);
            setLoading(false);
          });
      }
    } else {
      setLoading(false);
      setData([]);
      setApiCalled(false);
    }
  }, [selectedFilters, filterTabs]);

  const goBack = () => navigate('/dashboards');

  const renderSelectedFilters = () => {
    let renderedTransYear = false; // Flag to track if 'trans_year' has been rendered
    const subCategoryValues = []; // To accumulate sub-category values
    const renderContent = [];
    const brandValues = [];

    // Loop through the filter names and render them
    Object.keys(DisplayFiltersName).map((displayName) => {
      const filterKey = DisplayFiltersName[displayName]; // Get the object for the current display name

      // If the filterKey is an array (like 'trans_year' or any other arrays), handle them
      if (Array.isArray(filterKey)) {
        // If it's 'trans_year' and has not been rendered, render it
        if (displayName === "trans_year" && !renderedTransYear) {
          renderedTransYear = true;
          renderContent.push(
            <span key={displayName} className="selected-filter">
              <strong>Year: </strong>{filterKey.join(", ")}
            </span>
          );
        }
        return; // Skip further handling for arrays (no need to process this again)
      }

      // Get the keys from the filterKey object (like user_age, user_gender)
      const filterKeys = Object.keys(filterKey);

      // Loop through each filter key (like user_age, user_gender)
      filterKeys.map((key) => {
        const filterValues = selectedFilters[key];

        // Skip rendering if filterValues is empty or undefined
        if (!filterValues || (Array.isArray(filterValues) && filterValues.length === 0)) {
          return null;
        }

        // Skip rendering 'trans_year' if it's already been rendered
        if (key === "trans_year" && renderedTransYear) {
          return; // Skip if 'trans_year' has already been rendered
        }

        // ✅ Handle Sub-Categories
        if (displayName === "Sub-Categories" || key.startsWith("SubCat_")) {
          if (Array.isArray(filterValues)) {
            subCategoryValues.push(...filterValues);
          } else {
            subCategoryValues.push(filterValues);
          }
          return null;
        }

        // ✅ Handle Brand
        if (displayName === "Brand" || key.startsWith("Brand_")) {
          if (Array.isArray(filterValues)) {
            brandValues.push(...filterValues);
          } else {
            brandValues.push(filterValues);
          }
          return null;
        }

        // For other filters, display the regular displayName
        const displayKey = key === "trans_year" ? "Year" : displayName;
        const displayValues = Array.isArray(filterValues) ? filterValues.join(", ") : filterValues;

        renderContent.push(
          <span key={key} className="selected-filter">
            <strong>{displayKey}: </strong>{displayValues}
          </span>
        );
      });
    });

    // ✅ Render Sub-Categories
    if (subCategoryValues.length > 0) {
      renderContent.push(
        <span key="sub-categories" className="selected-filter">
          <strong>Sub-Categories: </strong>{subCategoryValues.join(", ")}
        </span>
      );
    }

    // ✅ Render Brand
    if (brandValues.length > 0) {
      renderContent.push(
        <span key="brand" className="selected-filter">
          <strong>Brand: </strong>{brandValues.join(", ")}
        </span>
      );
    }

    return renderContent;
  };
  const estimatedWaves = waves.length > 0 ? waves.length : 3;
  const estimatedStatements = statements.length > 0 ? statements.length : 2;

  const colSpanValue =
    statements.length > 0
      ? estimatedWaves * estimatedStatements
      : estimatedWaves;

  const downloadTableData = async (selectedFilters) => {
    if (!data || !data.length) {
      alert("No data available to download.");
      return;
    }

    setIsDownloading(true); // show popup
    try {
      const response = await axios.post(
        `${config.API_BASE_URL}/download-data`,  // Replace with your actual API endpoint
        {
          selectedFilters: selectedFilters,
          FilterTabs: exportedFilters,
          Kpi: "OverallShares"
        },
        { responseType: 'blob' } // Ensures file download
      );

      // Create a download link
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'Overall Shares.xlsx'); // Change file name/format if needed
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (error) {
      console.error("Error downloading data:", error);
      alert("Failed to download data. Please try again.");
    } finally {
      setIsDownloading(false); // hide popup
    }
  };
  useEffect(() => {
    if (isDownloading) {
      document.body.classList.add('download-active');
    } else {
      document.body.classList.remove('download-active');
    }
  }, [isDownloading]);



  return (
    <div className="container">
      <Filters pageSpecificFilters="payment" />
      <div className="table-section">
        <div style={{ justifyContent: 'space-between', display: 'flex' }}>
          <button onClick={goBack} className="back-button">← Back</button>
          <button
            onClick={() => downloadTableData(selectedFilters)}
            className={`download-button ${!data?.length ? 'disabled' : ''}`}
            disabled={!data?.length}
          >
            <i className="fa fa-download"></i>&nbsp;
            <span className="download-text">Download Data</span>
          </button>
        </div>
        <div className="selected-filters-display">
          {renderSelectedFilters()}
        </div>

        <FilterTabs onFilterUpdate={handleFilterUpdate} />

        {loading && (
          <div className="loader-container">
            <div className="loader"></div>
          </div>
        )}

        {error && <div className="error">{error}</div>}

        {!loading && apiCalled && (
          <div>
            {data.length === 0 ? (
              <div className="no-data-message">
                No data to display for selected filter.
              </div>
            ) : (
              <div className="scrollable-table">
                <table>
                  <thead>
                    <tr>
                      <th className="total-transac">
                        <div>
                          <u>Total Transactions</u>
                          <br />
                          <label className="label">
                            <i>
                              <strong>Base:</strong> {baseValue}
                            </i>
                          </label>
                        </div>
                      </th>
                      <th
                        className="share-column"
                        colSpan={colSpanValue}
                      >
                        Share of Transactions
                      </th>
                    </tr>

                    <tr>
                      <th>Payment Methods</th>
                      {statements.length > 0 ? (
                        waves.map((wave) => (
                          <th key={`wave-${wave.Id}`} colSpan={statements.length}>
                            {wave.Name}
                          </th>
                        ))
                      ) : (
                        waves.map((wave) => (
                          <th key={`wave-${wave.Id}`}>{wave.Name}</th>
                        ))
                      )}
                    </tr>
                    {statements.length > 0 && (
                      <tr>
                        <th></th>
                        {waves.map((wave) =>
                          statements.map((stmt) => (
                            <th key={`stmt-${wave.Id}-${stmt.Id || stmt.sindex}}`}>{stmt.Name || stmt.Text}</th>
                          ))
                        )}
                      </tr>
                    )}
                    {statements.length > 0 ? (
                      // render with statements
                      <tr className="base-row">
                        <td>
                          <strong>
                            <i>Base: Weighed number of transactions</i>
                          </strong>
                        </td>
                        {waves.map((wave) =>
                          statements.map((stmt) => {
                            const baseRow = data.find(
                              (d) =>
                                (d.sindex === stmt.Index || d.sindex === stmt.sindex) &&
                                d.windex === wave.Index
                            );
                            return (
                              <td key={`base-${stmt.Id || stmt.sindex}-${wave.Id}`}>
                                {baseRow?.Base
                                  ? Math.round(baseRow.Base).toLocaleString()
                                  : '-'}
                              </td>
                            );
                          })
                        )}
                      </tr>
                    ) : (
                      // render without statements
                      <tr className="base-row">
                        <td>
                          <strong>
                            <i>Base: Weighed number of transactions</i>
                          </strong>
                        </td>
                        {waves.map((wave) => {
                          const value = data.find((d) => d.windex === wave.Index);
                          return (
                            <td key={`base-${wave.Id}`}>
                              {value && value.Base !== undefined
                                ? Math.round(value.Base).toLocaleString()
                                : '-'}
                            </td>
                          );
                        })}
                      </tr>
                    )}
                  </thead>

                  <tbody>
                    {brands.map((brand) => (
                      <tr
                        key={brand.Id}
                        style={{
                          backgroundColor: `${brand.Color}`,
                          textIndent: `${brand.Operator}`,
                        }}
                      >
                        <td>{brand.Name}</td>

                        {statements.length > 0
                          ? waves.map((wave) =>
                            statements.map((stmt) => {
                              const value = data.find(
                                (d) =>
                                  d.bindex === brand.Index &&
                                  d.windex === wave.Index &&
                                  (d.sindex === stmt.Index || d.sindex === stmt.sindex)
                              );
                              return (
                                <td
                                  key={`${brand.Id}-${wave.Id}-${stmt.Id || stmt.sindex}`}
                                  className={stmt.sindex === 'total' ? 'total-cell' : ''}
                                >
                                  {value && value.Perc !== undefined && parseFloat(value.Perc) > 0
                                    ? `${(Math.round(parseFloat(value.Perc) * 10) / 10).toFixed(1)}%`
                                    : '-'}

                                </td>
                              );
                            })
                          )
                          : waves.map((wave) => {
                            const value = data.find(
                              (d) =>
                                d.bindex === brand.Index &&
                                d.windex === wave.Index
                            );
                            return (
                              <td key={`${brand.Id}-${wave.Id}`}>
                                {value && value.Perc !== undefined && parseFloat(value.Perc) > 0
                                  ? `${(Math.round(parseFloat(value.Perc) * 10) / 10).toFixed(1)}%`
                                  : '-'}

                              </td>
                            );
                          })}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        )}

      </div>
      {isDownloading && (
        <div className="download-popup">
          <div className="popup-content">
            <div className="spinner"></div>
            <p>Preparing your download...</p>
          </div>
        </div>
      )}

    </div>
  );
};

export default PaymentTable;
